import React from 'react';
import './form.styles.scss';
import ReactBootstrapForm, { FormProps as ReactBootstrapFormProps } from 'react-bootstrap/Form';
import Button, { ButtonProps } from '@/components/button/button.component';

interface FormProps extends ReactBootstrapFormProps {
  children: React.ReactNode;
}

interface GroupProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  children: React.ReactNode;
}

interface InputContainerProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  children: React.ReactNode;
}

const Form: React.FC<FormProps> = ({ children, ...rest }) => {
  return (
    <ReactBootstrapForm
      {...rest}
      noValidate
      autoComplete="on"
      className={(rest.className ?? '') + ' form'}
    >
      {children}
    </ReactBootstrapForm>
  );
};

const Label = ReactBootstrapForm.Label;
const Feedback = ReactBootstrapForm.Control.Feedback;

type ControlProps = React.ComponentProps<typeof ReactBootstrapForm.Control>;

const Control = React.forwardRef<HTMLInputElement, ControlProps>(
  ({ id, isInvalid, ...rest }, ref) => (
    <ReactBootstrapForm.Control
      {...rest}
      ref={ref}
      id={id}
      isInvalid={isInvalid}
      aria-invalid={isInvalid || undefined}
      aria-describedby={isInvalid && id ? `${id}-feedback` : undefined}
    />
  ),
);
Control.displayName = 'Form.Control';

const Group: React.FC<GroupProps> = ({ children, ...rest }) => {
  return (
    <div {...rest} className={(rest.className ?? '') + ' form__group'}>
      {children}
    </div>
  );
};

const InputContainer: React.FC<InputContainerProps> = ({ children, ...rest }) => {
  return (
    <div {...rest} className={(rest.className ?? '') + ' form__input-container'}>
      {children}
    </div>
  );
};

const Submit: React.FC<ButtonProps> = (props) => {
  return <Button {...props} type="submit" className={(props.className ?? '') + ' form__submit'} />;
};

export default Object.assign(Form, {
  Label,
  Control,
  Feedback,
  Group,
  InputContainer,
  Submit,
});
